import React from 'react';

import { BrancheDtoBrancheEnum } from 'lib_api/lib/api/gen';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { FormInputProps } from 'components/BaseForm/types';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import { BrancheFormField, BrancheFormValue } from '../type';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: BrancheFormValue;
  title: string;
  submit: (values: BrancheFormValue) => void;
  isSubmitting: boolean;
  validate: (
    field: BrancheFormField,
    values: BrancheFormValue,
  ) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<FormInputProps<BrancheFormValue, BrancheFormField>> = [
    {
      name: 'nature',
      label: 'Nature',
      field: BrancheFormField.NATURE,
      required: true,
    },
    {
      name: 'branche',
      label: 'Branche',
      field: BrancheFormField.BRANCHE,
      required: true,
      render: () => {
        return (
          <BaseSelect
            options={Object.keys(BrancheDtoBrancheEnum)}
            getOptionValue={option => option}
            getOptionLabel={option => option}
          />
        );
      },
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
